<div
  bp-card
  class="flex items-center w-full"
  [ngClass]="{ 'cursor-pointer': callback?.fullCardClick && !isDisabled, 'opacity-50': isDisabled }"
  (click)="callback?.fullCardClick && !isDisabled ? callback?.callback?.() : null"
  mat-ripple
>
  @if (!goal) {
    <!-- Skeleton -->
    <div
      class="max-w-full mr-6 bg-gray-200 rounded-full h-15 w-15 dark:bg-gray-700 animate-pulse"
    ></div>
  }
  @if (goal) {
    <div class="relative">
      <img
        [src]="goal?.imageSmall"
        [alt]="goal?.title"
        class="object-cover object-center mr-6 rounded-full w-15 h-15"
      />
      @if (hasStarred && goal.starred) {
        <button
          class="absolute scale-[.65] right-[7px] bottom-[-8px] bg-white shadow-lg md:hidden"
          mat-icon-button
        >
          <mat-icon class="text-yellow-400 icon-size-5">star</mat-icon>
        </button>
      }
    </div>
  }
  <div class="flex flex-col">
    <!-- Skeleton -->
    @if (!goal) {
      <div
        class="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-[160px] max-w-full mb-3 animate-pulse"
      ></div>
      <div
        class="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-[260px] max-w-full mb-3 animate-pulse"
      ></div>
      <div
        class="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-[160px] max-w-full mb-3 animate-pulse"
      ></div>
    }
    <!-- Si ya hay una meta carga la tarjeta -->
    @if (goal) {
      @if (goalInfoType !== goalInfoTypeEnum.NONE) {
        <div class="text-md">
          {{ goalInfoType === goalInfoTypeEnum.IS_FROM ? 'Desde' : 'En' }}
        </div>
      }
      <div class="text-xl font-semibold leading-tight">
        {{ goal?.title }}
        @if (hasStarred && goal.starred) {
          <mat-icon class="absolute hidden ml-1 text-yellow-400 icon-size-5 md:inline"
            >star</mat-icon
          >
        }
      </div>
      <span class="inline">
        <span class="inline align-text-bottom text-md text-secondary">
          {{
            goal?.currentCapital
              | currency
                : goal?.currency?.currencyCode
                : goal?.currency?.display
                : goal?.currency?.digitsInfo
          }}
        </span>
        @if (hasTooltip) {
          <mat-icon
            matTooltipPosition="right"
            (click)="tooltip.toggle()"
            #tooltip="matTooltip"
            matTooltip="Tu saldo disponible puede ser distinto del balance ya que considera las transacciones en proceso y el rebalanceo de cajas."
            class="inline text-base align-baseline cursor-pointer text-secondary"
            >help_outline</mat-icon
          >
        }
      </span>
    }
  </div>

  @if (callback && goal && !isDisabled) {
    @if (callback.text) {
      <button mat-button color="primary" class="ml-auto" (click)="callback?.callback()">
        {{ callback.text }}
      </button>
    }
    @if (!callback.text) {
      <mat-icon
        [svgIcon]="'heroicons_outline:chevron-right'"
        class="ml-auto cursor-pointer icon-size-5"
      ></mat-icon>
    }
  }
</div>
